import React, { useEffect, useRef } from 'react';

const OutsideClickHandler = ({ children, onOutsideClick }) => {
    const containerRef = useRef(null);
  
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        // Clicked outside the container, trigger the callback
        onOutsideClick();
      }
    };
  
    useEffect(() => {
      // Attach the event listener when the component mounts
      document.addEventListener('click', handleClickOutside);
  
      // Detach the event listener when the component unmounts
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, []); // Empty dependency array ensures that the effect runs only once on mount
  
    return <div className='user-actions-section' ref={containerRef}>{children}</div>;
  };

export default OutsideClickHandler;
